










































































































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';
import {Prominence, Duration} from '../api/common';

import StressMarker from '../api/stressMarker';

import Modal from '@/components/Modal.vue';
import FieldAudio from '@/components/FieldAudio.vue';
import FieldHints from '../components/FieldHints.vue';
import FieldTextRange from '../components/FieldTextRange.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import DropDownText from '../components/DropDownText.vue';

@Component({
    components: {
        'drop-down-text': DropDownText,
        'modal': Modal,
        'field-audio': FieldAudio,
        'field-hints': FieldHints,
        'field-text-range': FieldTextRange,
        'edit-icon': EditIcon,
    },
})
export default class FieldStressMarkers extends CommonVue {
    @Model() public stress_markers!: StressMarker[];

    @Prop({type: String}) public sentence!: string;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Boolean, default: false}) public isSentenceStress?: boolean;

    public stressMarker: StressMarker = null;
    public showModal: boolean = false;

    public prominenceOptions = Prominence.OPTIONS;
    public durationOptions = Duration.OPTIONS;

    public prominencePresentation = Prominence.PRESENTATION;
    public durationPresentation = Duration.PRESENTATION;

    public newStressMarker() {
        this.stressMarker = new StressMarker();
        this.showModal = true;
    }
    public changeWord(stressMarker, isChangeStressMaker){
        if(isChangeStressMaker){
            stressMarker.word_start_index = stressMarker.start_index;
            stressMarker.word_end_index = stressMarker.end_index;
        }
    }

    public edit(stressMarker: StressMarker) {
        this.stressMarker = stressMarker;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.stressMarker) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.stressMarker.state === 'created') {
                this.stress_markers.push(this.stressMarker);
            }
            this.stressMarker.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save stressMarker', e);
        }
    }

    public checkMandatoryFields() {
        // Check if start index is filled
        if (this.stressMarker.start_index === undefined || this.stressMarker.start_index === -1) {
            throw Error('Please select a range for your stress marker.');
        }

        // Check if end index is filled
        if (this.stressMarker.end_index === undefined || this.stressMarker.end_index === -1) {
            throw Error('Please select a range for your stress marker.');
        }

        if (this.isSentenceStress) {
            if (!this.stressMarker.prominence) {
                throw Error('Please select prominence');
            }

            if (!this.stressMarker.duration) {
                throw Error('Please select duration');
            }
        }

    }

    public deleteClicked() {
        this.stressMarker.state = 'deleted';
        this.showModal = false;
    }

}
